function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m0.44624 20.09c0-10.778 8.7498-19.527 19.527-19.527 10.815 0 19.527 8.7498 19.527 19.527 0 10.815-8.7123 19.527-19.527 19.527-10.778 0-19.527-8.7123-19.527-19.527z",
  fill: "#fff",
  fillRule: "evenodd"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "icon-tertiary",
  d: "m0.44624 20.09c0-10.778 8.7498-19.527 19.527-19.527 10.815 0 19.527 8.7498 19.527 19.527 0 10.815-8.7123 19.527-19.527 19.527-10.778 0-19.527-8.7123-19.527-19.527",
  fill: "none",
  stroke: "#002060",
  strokeMiterlimit: 9
});
var _ref4 = /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.37791 .57819 -.57566 .37625 21.907 -1.5705)",
  strokeWidth: 3.7937
}, React.createElement("g", {
  transform: "matrix(.38369 0 0 .38124 1.9308 .23764)",
  fillRule: "evenodd"
}, React.createElement("path", {
  className: "icon-secondary",
  d: "m24.856 64.348c-16.918-4.83-26.717-22.461-21.887-39.379 1.716-6.008 5.16-11.379 9.905-15.445l20.728 24.192z",
  fill: "#adb9ca"
}), React.createElement("path", {
  d: "m54.768 9.906c13.149 11.689 14.334 31.825 2.644 44.975-8.133 9.149-20.789 12.829-32.559 9.466l8.749-30.631z",
  fill: "#fff"
}), React.createElement("path", {
  className: "icon-primary",
  d: "m12.945 9.464c12.13-10.332 30.027-10.114 41.901 0.512l-21.244 23.74z",
  fill: "#ecaec6"
})), React.createElement("g", {
  className: "icon-tertiary",
  transform: "matrix(.38369 0 0 .38124 1.9308 .23764)",
  fill: "none",
  stroke: "#002060"
}, React.createElement("path", {
  d: "m24.755 64.277 8.755-30.655 21.214-23.671",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10
}), React.createElement("path", {
  d: "m12.874 9.524 20.636 24.098",
  strokeMiterlimit: 8
}), React.createElement("path", {
  d: "m9.411 54.444c-11.448-13.36-9.897-33.472 3.463-44.92s33.471-9.897 44.919 3.463c11.448 13.361 9.898 33.472-3.462 44.92-13.361 11.448-33.472 9.897-44.92-3.463z",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10
})));
var _ref5 = /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.71736 0 0 .71448 -7.7467 11.009)",
  strokeMiterlimit: 8
}, React.createElement("g", {
  className: "icon-tertiary",
  transform: "matrix(.38369 0 0 .38124 1.9308 .23764)",
  fill: "#fff",
  fillRule: "evenodd",
  stroke: "#002060",
  strokeWidth: 3.6521
}, React.createElement("path", {
  d: "m108.86 43.5 0.276 0.419c2.782 2.836 6.625 4.59 10.869 4.59 4.245 0 8.088-1.754 10.869-4.59l0.277-0.419 2.254 0.464c6.523 2.814 11.1 9.4 11.1 17.077v15.537l-7.943 2.944c-5.371 1.302-10.923 1.978-16.557 1.978s-11.186-0.676-16.557-1.978l-7.943-2.944v-15.537c0-7.677 4.577-14.263 11.1-17.077z"
}), React.createElement("path", {
  d: "m104.5 35c0-8.56 6.94-15.5 15.5-15.5s15.5 6.94 15.5 15.5-6.94 15.5-15.5 15.5-15.5-6.94-15.5-15.5z"
})), React.createElement("g", {
  strokeWidth: 1.3968
}, React.createElement("path", {
  className: "icon-secondary",
  d: "m25.28 16.821 0.1059 0.15974c1.0674 1.0812 2.5419 1.7499 4.1703 1.7499 1.6287 0 3.1033-0.66869 4.1703-1.7499l0.10628-0.15974 0.86483 0.17689c2.5028 1.0728 4.2589 3.5836 4.2589 6.5104v5.9233l-3.0476 1.1224c-2.0608 0.49637-4.191 0.75409-6.3527 0.75409s-4.2919-0.25772-6.3527-0.75409l-3.0476-1.1224v-5.9233c0-2.9268 1.7561-5.4376 4.2589-6.5104z",
  fill: "#adb9ca",
  fillRule: "evenodd"
}), React.createElement("path", {
  className: "icon-tertiary",
  d: "m25.28 16.821 0.1059 0.15974c1.0674 1.0812 2.5419 1.7499 4.1703 1.7499 1.6287 0 3.1033-0.66869 4.1703-1.7499l0.10628-0.15974 0.86483 0.17689c2.5028 1.0728 4.2589 3.5836 4.2589 6.5104v5.9233l-3.0476 1.1224c-2.0608 0.49637-4.191 0.75409-6.3527 0.75409s-4.2919-0.25772-6.3527-0.75409l-3.0476-1.1224v-5.9233c0-2.9268 1.7561-5.4376 4.2589-6.5104z",
  fill: "none",
  stroke: "#002060"
}), React.createElement("path", {
  className: "icon-secondary",
  d: "m23.609 13.581c0-3.2634 2.6628-5.9092 5.9471-5.9092 3.2844 0 5.9471 2.6458 5.9471 5.9092s-2.6628 5.9092-5.9471 5.9092c-3.2844 0-5.9471-2.6458-5.9471-5.9092z",
  fill: "#adb9ca",
  fillRule: "evenodd"
})), React.createElement("g", {
  transform: "matrix(.38369 0 0 .38124 1.9308 .23764)",
  strokeWidth: 3.6521
}, React.createElement("path", {
  className: "icon-tertiary",
  d: "m56.5 35c0-8.56 6.94-15.5 15.5-15.5s15.5 6.94 15.5 15.5-6.94 15.5-15.5 15.5-15.5-6.94-15.5-15.5z",
  fill: "none",
  stroke: "#002060"
}), React.createElement("path", {
  className: "icon-primary",
  d: "m83.945 51.5 0.299 0.452c3.009 3.06 7.165 4.953 11.756 4.953s8.748-1.893 11.756-4.953l0.3-0.452 2.438 0.501c7.055 3.035 12.006 10.142 12.006 18.425v16.764l-8.592 3.176c-5.808 1.404-11.814 2.134-17.908 2.134s-12.1-0.73-17.908-2.134l-8.592-3.176v-16.764c0-8.283 4.951-15.39 12.006-18.425z",
  fill: "#ecaec6",
  fillRule: "evenodd"
}), React.createElement("path", {
  className: "icon-tertiary",
  d: "m83.945 51.5 0.299 0.452c3.009 3.06 7.165 4.953 11.756 4.953s8.748-1.893 11.756-4.953l0.3-0.452 2.438 0.501c7.055 3.035 12.006 10.142 12.006 18.425v16.764l-8.592 3.176c-5.808 1.404-11.814 2.134-17.908 2.134s-12.1-0.73-17.908-2.134l-8.592-3.176v-16.764c0-8.283 4.951-15.39 12.006-18.425z",
  fill: "none",
  stroke: "#002060"
})), React.createElement("path", {
  className: "icon-primary",
  d: "m32.05 16.25c0-3.4742 2.9202-6.2904 6.5227-6.2904 3.6024 0 6.5227 2.8162 6.5227 6.2904s-2.9202 6.2904-6.5227 6.2904c-3.6024 0-6.5227-2.8162-6.5227-6.2904z",
  fill: "#ecaec6",
  fillRule: "evenodd",
  strokeWidth: 1.3968
}), React.createElement("path", {
  className: "icon-tertiary",
  d: "m32.05 16.25c0-3.4742 2.9202-6.2904 6.5227-6.2904 3.6024 0 6.5227 2.8162 6.5227 6.2904s-2.9202 6.2904-6.5227 6.2904c-3.6024 0-6.5227-2.8162-6.5227-6.2904z",
  fill: "none",
  stroke: "#002060",
  strokeWidth: 1.3968
}));
var SvgMenuParticipationIcon = function SvgMenuParticipationIcon(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, ["svgRef"]);
  return React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5);
};
var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMenuParticipationIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/menu-participation-icon.6ea70e87.svg";
export { ForwardRef as ReactComponent };